import React, { useState } from 'react';
import { FiUser, FiMail, FiLock, FiCheck, FiX } from 'react-icons/fi';

const UserModal = ({ 
  isOpen, 
  closeModal, 
  modalMode, 
  formData, 
  handleInputChange, 
  handleSubmit,
  allUsers = [],
  currentUserId,
  handleAliasChange
}) => {
  const [activeTab, setActiveTab] = useState('info');
  
  if (!isOpen) return null;
  
  // Handler for clicking outside modal content
  const handleBackdropClick = (e) => {
    if (e.target.className === 'modal-backdrop') {
      closeModal();
    }
  };
  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>{modalMode === 'add' ? 'Adicionar Usuário' : 'Editar Usuário'}</h3>
          <button className="modal-close" onClick={closeModal}>
            <FiX />
          </button>
        </div>
        
        <div className="modal-tabs" style={{
          display: 'flex',
          borderBottom: '1px solid #e0e0e0',
          marginBottom: '20px'
        }}>
          <button
            type="button"
            className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
            onClick={() => setActiveTab('info')}
            onMouseEnter={(e) => {
              if (activeTab !== 'info') {
                e.target.style.backgroundColor = '#f5f5f5';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'info') {
                e.target.style.backgroundColor = 'transparent';
              }
            }}
            style={{
              padding: '12px 24px',
              background: activeTab === 'info' ? '#fff' : 'transparent',
              border: 'none',
              borderBottom: activeTab === 'info' ? '2px solid #3E5F56' : '2px solid transparent',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === 'info' ? '600' : '400',
              color: activeTab === 'info' ? '#3E5F56' : '#666',
              transition: 'all 0.2s ease'
            }}
          >
            <FiUser style={{ marginRight: '8px' }} />
            Informações Básicas
          </button>
          <button
            type="button"
            className={`tab-button ${activeTab === 'aliases' ? 'active' : ''}`}
            onClick={() => setActiveTab('aliases')}
            onMouseEnter={(e) => {
              if (activeTab !== 'aliases') {
                e.target.style.backgroundColor = '#f5f5f5';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'aliases') {
                e.target.style.backgroundColor = 'transparent';
              }
            }}
            style={{
              padding: '12px 24px',
              background: activeTab === 'aliases' ? '#fff' : 'transparent',
              border: 'none',
              borderBottom: activeTab === 'aliases' ? '2px solid #3E5F56' : '2px solid transparent',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === 'aliases' ? '600' : '400',
              color: activeTab === 'aliases' ? '#3E5F56' : '#666',
              transition: 'all 0.2s ease'
            }}
          >
            <FiMail style={{ marginRight: '8px' }} />
            Aliases de Email
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="user-form">
          {activeTab === 'info' ? (
          <React.Fragment>
          <div className="form-group">
            <label htmlFor="nomeCompleto" style={{ marginBottom: '8px', display: 'block' }}>
              <FiUser style={{ marginRight: '8px' }} />
              Nome Completo
            </label>
            <input
              type="text"
              id="nomeCompleto"
              name="nomeCompleto"
              className="form-control"
              value={formData.nomeCompleto}
              onChange={handleInputChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="username" style={{ marginBottom: '8px', display: 'block' }}>
              <FiUser style={{ marginRight: '8px' }} />
              Nome de Usuário
            </label>
            <input
              type="text"
              id="username"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleInputChange}
              required
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email" style={{ marginBottom: '8px', display: 'block' }}>
                <FiMail style={{ marginRight: '8px' }} />
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="email@exemplo.com"
                title="Email do usuário (editável)"
              />
              <small style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
                Email gerado automaticamente: username@veridicus.com.br
              </small>
            </div>
            
            <div className="form-group">
              <label htmlFor="role" style={{ marginBottom: '8px', display: 'block' }}>
                <i className="fas fa-user-tag" style={{ marginRight: '8px' }}></i>
                Função
              </label>
              <select
                id="role"
                name="role"
                className="form-select"
                value={formData.role}
                onChange={handleInputChange}
              >
                <option value="master">Master</option>
                <option value="diretoria">Diretoria</option>
                <option value="associado">Associado</option>
                <option value="financeiro">Financeiro</option>
                <option value="suporte">Suporte</option>
              </select>
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="password" style={{ marginBottom: '8px', display: 'block' }}>
                <FiLock style={{ marginRight: '8px' }} />
                Senha
                {modalMode === 'edit' && (
                  <span style={{ fontSize: '11px', display: 'block', marginTop: '2px', color: '#666' }}>
                    (deixe em branco para manter a atual)
                  </span>
                )}
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleInputChange}
                required={modalMode === 'add'}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmPassword" style={{ marginBottom: '8px', display: 'block' }}>
                <FiLock style={{ marginRight: '8px' }} />
                Confirmar Senha
              </label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className="form-control"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required={modalMode === 'add'}
              />
            </div>
          </div>
          </React.Fragment>
          ) : (
            <div className="aliases-tab">
              <p style={{ marginBottom: '16px', color: '#666', fontSize: '14px' }}>
                Selecione os usuários cujos emails este usuário poderá gerenciar:
              </p>
              
              <div style={{ 
                maxHeight: '300px', 
                overflowY: 'auto',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                padding: '12px'
              }}>
                {allUsers
                  .filter(user => 
                    // Don't show the current user being edited
                    modalMode === 'edit' ? user._id !== currentUserId : true
                  )
                  .map(user => {
                    const userEmail = user.email || `${user.username}@veridicus.com.br`;
                    const isChecked = formData.emailAlias && formData.emailAlias.includes(user._id);
                    
                    return (
                      <label 
                        key={user._id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '8px',
                          marginBottom: '8px',
                          backgroundColor: isChecked ? '#f0f7e0' : '#f8f9fa',
                          border: `1px solid ${isChecked ? '#c3d9a3' : '#e9ecef'}`,
                          borderRadius: '4px',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => handleAliasChange(user._id)}
                          style={{
                            marginRight: '12px',
                            width: '18px',
                            height: '18px',
                            cursor: 'pointer'
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: '500', marginBottom: '2px' }}>
                            {user.nomeCompleto || user.username}
                          </div>
                          <div style={{ fontSize: '13px', color: '#666' }}>
                            {userEmail}
                          </div>
                        </div>
                      </label>
                    );
                  })
                }
                
                {allUsers.filter(user => modalMode === 'edit' ? user._id !== currentUserId : true).length === 0 && (
                  <div style={{ 
                    textAlign: 'center', 
                    padding: '20px',
                    color: '#999' 
                  }}>
                    Nenhum usuário disponível para adicionar como alias
                  </div>
                )}
              </div>
              
              <div style={{ 
                marginTop: '16px',
                padding: '12px',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                fontSize: '13px',
                color: '#666'
              }}>
                <strong>Nota:</strong> Usuários selecionados poderão enviar e receber emails em nome deste usuário.
              </div>
            </div>
          )}
          
          <div className="modal-footer" style={{ marginTop: '24px' }}>
            <button
              type="button"
              className="configuracoes-btn configuracoes-btn-secondary"
              onClick={closeModal}
              style={{ backgroundColor: '#3E5F56', color: 'white' }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="configuracoes-btn configuracoes-btn-primary"
            >
              <FiCheck style={{ marginRight: '8px' }} />
              {modalMode === 'add' ? 'Adicionar' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserModal;